import { render } from "./DynamicKlineChart.vue?vue&type=template&id=6a32f866"
import script from "./DynamicKlineChart.vue?vue&type=script&lang=js"
export * from "./DynamicKlineChart.vue?vue&type=script&lang=js"

import "./DynamicKlineChart.vue?vue&type=style&index=0&id=6a32f866&lang=css"

import exportComponent from "E:\\量化\\my-websit-ai - 副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__